import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { ApiFinanceira } from '../axiosfinanceiro';

export interface IConfirmarVale {
    idoperacao: string;
    nome: string;
    dataemissao: Date;
    historico: string;
    totalvale: number;
  }

export interface IValeConfirmar{
    idoperacao: string;
    idconta: number;
    databaixa: Date;
    historico: string;
    totalvale: number;
  }

type TotalCount = {
    data: IConfirmarVale[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, ): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/valeconfirmar?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}`;
    const { data, headers } = await ApiFinanceira.get(urlRelativa); 
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Confirmar = async (dados: IValeConfirmar): Promise<void | Error> => {
  try {  
    await ApiFinanceira.post('/valeconfirmar', dados); 
    return;   
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const ValesFinanceiroConstasService = {  
  getAll, 
  Confirmar,  
};